__turbopack_context__.v({
  "eyebrow": "Xebo-W_eyebrow",
  "figure": "Xebo-W_figure",
  "head": "Xebo-W_head",
  "lead": "Xebo-W_lead",
  "mobileNodeLabel": "Xebo-W_mobileNodeLabel" + " " + "Xebo-W_nodeLabel",
  "nodeLabel": "Xebo-W_nodeLabel",
  "plot": "Xebo-W_plot",
  "plotMobile": "Xebo-W_plotMobile",
  "section": "Xebo-W_section",
  "title": "Xebo-W_title",
});
